export function hexToRgb(hex) {
  // Remove the hash at the start if it's there
  hex = hex.replace(/^#/, '');

  // Parse the R, G, B values
  const red = parseInt(hex.substring(0, 2), 16);
  const green = parseInt(hex.substring(2, 4), 16);
  const blue = parseInt(hex.substring(4, 6), 16);

  return { red, green, blue }; // Return an object with R, G, B values
}

export function getOptimalTextColor(hex) {
  if (!hex) {
    return '#333333';
  }
  // Remove the hash at the start if it's there
  const { red, green, blue } = hexToRgb(hex);

  // Calculate luminance
  const luminance = 0.299 * red + 0.587 * green + 0.114 * blue;

  // Determine text color
  return luminance > 128 ? '#333333' : '#FFFFFF'; // Black or white
}

export function checkIsFullyTransparent(color) {
  if (typeof color !== 'string') {
    return false;
  }
  if (color === 'transparent') {
    return true;
  }
  // if color is hex, check last two characters
  if (color[0] === '#') {
    return color.length === 9 && color.slice(-2) === '00';
  }
  // if color is rgba, check last two characters
  if (color.slice(0, 4) === 'rgba') {
    const rgbaValues = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),\s*([\d.]+)\)/);
    return rgbaValues && parseFloat(rgbaValues[4]) === 0;
  }
  // if color is rgb, check last two characters
  if (color.slice(0, 3) === 'rgb') {
    const rgbValues = color.match(/rgb\((\d+),\s*(\d+),\s*(\d+)\)/);
    return rgbaValues && rgbValues[1] === '0' && rgbValues[2] === '0' && rgbValues[3] === '0';
  }
  return false;
};

export function normalizeHexColor(hex) {
  if (typeof hex !== 'string' || !hex.startsWith('#')) {
    return null;
  }

  // Remove the hash
  const cleanHex = hex.slice(1);

  // Convert 3-digit hex to 6-digit hex
  if (cleanHex.length === 3) {
    return '#' + cleanHex.split('').map(char => char + char).join('');
  }

  // Return 6-digit hex as-is (convert to lowercase for consistency)
  if (cleanHex.length === 6) {
    return '#' + cleanHex.toLowerCase();
  }

  return null;
}

export function areHexColorsEqual(color1, color2) {
  const normalized1 = normalizeHexColor(color1);
  const normalized2 = normalizeHexColor(color2);

  if (normalized1 === null || normalized2 === null) {
    return false;
  }

  return normalized1 === normalized2;
}